import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/true-wine/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={714}
              height={549}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#207146" }}>Solution</span>
            </h2>
            <p>
              Our team took the challenge to heart and produced a vibrant social
              networking platform with a range of advanced features. We
              integrated load shifting algorithms on the server to ensure
              seamless operation, and collaborated with reliable broadcasting
              service providers to enable quality live streaming of events. In
              addition to this, we made sure that all transactions that take
              place through the app remain secure through data encryption.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
